import React from 'react';
import SbEditable from 'storyblok-react';

import Components from '../components';
import './split-content.scss';

const SplitContent = (props) => {
  const classes = ['split-content'];

  if (props.blok.vertical_alignment) {
    classes.push('vertical-align-' + props.blok.vertical_alignment);
  }

  if (props.blok.content_alignment) {
    classes.push('col-' + props.blok.content_alignment);
  }

  classes.push('split-' + (props.blok.split || '50_50'));

  return (
    <SbEditable content={props.blok}>
      <section className={classes.join(' ')}>
        <div className="left">
          {props.blok.left &&
            props.blok.left.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
        </div>
        <div className="right">
          {props.blok.right &&
            props.blok.right.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
        </div>
      </section>
    </SbEditable>
  );
};

export default SplitContent;
